export function defaultDiff() {
  return {
    color: {},
    hint: {},
    supprime: {},
  };
}
